import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const DoneAllIcon = (props: SVGProps) => {
  return <SpriteIcon spriteId="done-check" {...props} />;
};

export { DoneAllIcon };
